import { useDispatch } from "react-redux";
import { AppDispatch } from "core/src/store/store.types";
import { NavigateRequest, navigate as navigateUC } from "./useCases/navigate/navigate.use-case";
import { UpdateLocationRequest, updateLocation as updateLocationUC } from "./useCases/update-location/updateLocation.use-case";

export const useNavigationUseCases = () => {
	const dispatch = useDispatch<AppDispatch>();

	const navigate = (args: NavigateRequest) => dispatch(navigateUC(args));
	const updateLocation = (args: UpdateLocationRequest) => dispatch(updateLocationUC(args));

	return {
		navigate,
		updateLocation,
	};
};

export type UseNavigationUseCases = ReturnType<typeof useNavigationUseCases>;
